export default "__VITE_ASSET__9itw2o2v__"